import { Badge } from "ui/components/badge";
import { useTimesheet } from "./context";
import React from "react";

const HeaderTitle = ({ className, children, ...props }) => {
  const {
    data: { day, date },
  } = useTimesheet();

  return (
    <h2 className={className} {...props}>
      {typeof children === "function" ? children({ date }) : children || day}
    </h2>
  );
};

const HeaderDescription = ({ className, children, ...props }) => {
  const {
    data: { formattedDate },
  } = useTimesheet();

  return (
    <p className={className} {...props}>
      {typeof children === "function"
        ? children({ day })
        : children || formattedDate}
    </p>
  );
};

const TotalHoursBadge = ({ className, children, ...props }) => {
  const {
    data: { totalLogsInADay },
  } = useTimesheet();

  // Combine base className with conditional red background for zero hours
  const combinedClassName = `${className || ''} ${
    totalLogsInADay === 0 ? 'bg-red-50 text-red-900' : 'bg-zinc-100 text-black'
  } rounded-full`.trim();

  return (
    <Badge className={combinedClassName} {...props}>
      {typeof children === "function"
        ? children({ totalLogsInADay })
        : children || totalLogsInADay}
      {" "}Hours
    </Badge>
  );
};

export { HeaderTitle, HeaderDescription , TotalHoursBadge };
